import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import orderHistory from "./orderHistory.js";
import customers from "./customers.js";
import walletLogs from "./walletLogs.js";
import donations from "./donations.js";
import './crmstyles.css'
const Users = ({ match }) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}`} to={`${match.url}/crm`} />
      <Route path={`${match.url}/customers`} component={customers} />
      <Route path={`${match.url}/orders`} component={orderHistory} />
      <Route path={`${match.url}/wallet-logs`} component={walletLogs} />
      <Route path={`${match.url}/donations`} component={donations} />
      <Redirect to="/error" />
    </Switch>
  </div>
);

export default Users;
